export default __webpack_public_path__ + "static/media/foto4.6d2fb165.JPG";